var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('checkbox',{on:{"change":_vm.toggleHidden},model:{value:(_vm.isHidden),callback:function ($$v) {_vm.isHidden=$$v},expression:"isHidden"}},[_vm._v(" Hide on "+_vm._s(_vm.env))])}
var staticRenderFns = []

export { render, staticRenderFns }